import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import * as LimitRoute from "./limit";
import * as NewRoute from "./new";
import * as ListRoute from "./list";

const LocalProvider = ({ match: { params, params: { limitId } }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/limit`;
  const basepath = `${parentBasepath}/limit`;

  return (
    <Section.Provider
      schema={[...schema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath, parent }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:limitId`} component={LimitRoute.Content} />
          <Route
            path={`${basepath}/`}
            component={ListRoute.Content}
          />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={`${base}`}>Limits</Link>
          </BreadcrumbItem>

          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:limitId`} component={LimitRoute.Indice} />
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <>
</>;
